export default "__VITE_ASSET__CugPyLte__"